// # Achievements section component for profile
import React from 'react';
import './prfl_achievements.css';

const ProfileAchievements = ({ isDarkMode }) => {
  return (
    <div className={`prfl_achievements_container ${isDarkMode ? 'prfl_dark-mode' : ''}`}>
      <div className="prfl_achievements_coming-soon">
        <h3>Achievements Feature Coming Soon</h3>
        <p>Track your medical education milestones and accomplishments.</p>
      </div>
    </div>
  );
};

export default ProfileAchievements;
